import List from './actions/list';
import Find from './actions/find';
import Create from './actions/create';
import Update from './actions/update';
import Delete from './actions/delete';
import Resource from './resource';

export default class Workflow extends Resource {
  get resourceName() {
    return 'workflow';
  }

  get resourcesName() {
    return 'workflows';
  }
}
// @ts-ignore
List.includeInto(Workflow);
// @ts-ignore
Find.includeInto(Workflow);
// @ts-ignore
Create.includeInto(Workflow);
// @ts-ignore
Update.includeInto(Workflow);
// @ts-ignore
Delete.includeInto(Workflow);
